module.exports = __webpack_public_path__ + "img/mahindra-rise-orig.f6dd0854.png";